import React, { useEffect, useState } from "react";

const DEFAULT_CLASS_NAME = "t-text-body-sm t-text-text-30 t-italic";

export const OtpResendTimer = ({
  setShowTimer,
  className = DEFAULT_CLASS_NAME,
}: {
  setShowTimer: (val: boolean) => void;
  className?: string;
}) => {
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds <= 1) {
          clearInterval(interval);
          setShowTimer(false);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [setShowTimer]);

  return (
    <div className={className}>
      Can’t find link? Check your spam folder or resend in {seconds} seconds
    </div>
  );
};
